import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { InformationTitleComponent } from '../../../../../../../components/ecosystems/information-title/information-title.component';
import {
  IonButton,
  IonContent,
  IonInput,
  ModalController,
} from '@ionic/angular/standalone';
import { LabelDescriptionComponent } from '../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { TwoChoicesModalComponent } from '../../../../../../../components/ecosystems/two-choices-modal/two-choices-modal.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-p00061-installation-identification-pac',
  templateUrl: './p00061-installation-identification-pac.component.html',
  styleUrls: ['./p00061-installation-identification-pac.component.scss'],
  imports: [
    HeaderConfigurationComponent,
    InformationTitleComponent,
    IonButton,
    IonContent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TranslatePipe,
    FormsModule,
    IonInput,
    ReactiveFormsModule,
  ],
})
export class P00061InstallationIdentificationPacComponent implements OnInit {
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private modalController: ModalController = inject(ModalController);
  private fb = inject(FormBuilder);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  private defaultData: any = null;
  public currentForm: FormGroup | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );

    this.initForm();
  }

  private initForm() {
    this.defaultData = JSON.stringify({
      wpWfCode: this.poolAdditionalData?.wpWfCode ?? '',
      wpSerialNumber: this.poolAdditionalData?.wpSerialNumber ?? '',
    });

    this.currentForm = this.fb.group({
      wpWfCode: [this.poolAdditionalData?.wpWfCode ?? ''],
      wpSerialNumber: [this.poolAdditionalData?.wpSerialNumber ?? ''],
    });
  }

  onSubmit() {
    var data = {
      wpWfCode: this.currentForm!.controls['wpWfCode']?.value,
      wpSerialNumber: this.currentForm!.controls['wpSerialNumber']?.value,
    };

    if (JSON.stringify(data) !== this.defaultData) {
      this.poolAdditionalData!.wpWfCode = data.wpWfCode;
      this.poolAdditionalData!.wpSerialNumber = data.wpSerialNumber;
    }

    this.next(this.actionStack!, this.poolAdditionalData!);
  }
}
